module.exports = __webpack_public_path__ + "img/area_4.bc198935.png";